import Vue from 'vue'

const resource = 'auth'

const applyPolicy = () => Vue.axios.post(`${resource}/apply-policy`)

export default {
  applyPolicy
}



// WEBPACK FOOTER //
// ./src/api/auth.js